import React from "react";
import style from "./index.module.scss";
import { Button, Col, Row, Select, Icon } from "antd";
import { CurrentTermType, downloadQuestionTemplate } from "service/answerStore";
import { useAtomValue } from "jotai";
import { termListAtom } from "service/stores/CommonStore";
import classNames from "classnames";

interface UploadExcelModalProps {
    batchNo: string; //学期编码
    onchangeBatchNo: (val: string) => void; //更新学期编码
}

export default function UploadExcelModal({
    batchNo,
    onchangeBatchNo
}: UploadExcelModalProps) {
    const { Option } = Select;
    const batchList = useAtomValue(termListAtom);

    const onPlay = () => {
        window.open(
            "http://go.plvideo.cn/front/video/view?vid=5c0ad4c56c2c658bc1c9069541703b07_5"
        );
    };

    return (
        <div>
            <Row className={style.row}>
                <Col span={22} className={style.label}>
                    1.
                    <Button
                        className={style.link}
                        type="link"
                        onClick={downloadQuestionTemplate}>
                        点击下载
                    </Button>
                    《题目导入模板》
                    <span className={style.tip} onClick={onPlay}>
                        <Icon type="play-square" />
                        点击查看使用说明视频
                    </span>
                </Col>
            </Row>
            <Row className={style.row}>
                <Col span={22} className={style.label}>
                    2.所属学期：
                    <Select
                        placeholder="请选择学期"
                        value={batchNo}
                        onChange={(val: string) => onchangeBatchNo(val)}>
                        {batchList.map(item => (
                            <Option
                                className={classNames({
                                    [style.option]:
                                        item.isCurrentTerm ===
                                        CurrentTermType.isCurrent
                                })}
                                value={item.batchNo}
                                key={item.batchNo}>
                                {item.batchName}
                            </Option>
                        ))}
                    </Select>
                </Col>
            </Row>
            <Row className={style.row}>
                <Col span={22} className={style.label}>
                    <i className={style.required}>*</i>
                    3.在导入模板补充好数据后上传文件
                </Col>
            </Row>
        </div>
    );
}
